import Flex from 'components/priority/Flex/Flex'
import Text from 'components/priority/Text/Text'
import { unsavedChangesAtom } from 'atoms'
import { isSavingAtom } from '@/atoms/_editorAtoms'
import { useRecoilValue } from 'recoil'
import { useTranslation } from 'react-i18next'

export const SavedStatus = ({ ...props }) => {
  const { t } = useTranslation()
  const unsavedChanges = useRecoilValue(unsavedChangesAtom)
  // A Save holds this from the moment it starts, before it has written
  // anything, so the wait for the line's version reads as work in progress
  // rather than as an editor that ignored the button.
  const isSaving = useRecoilValue(isSavingAtom)
  const status = isSaving
    ? t('editor.saving')
    : unsavedChanges
      ? t('editor.unsavedChanges')
      : t('editor.saved')
  // The same state as a value that does not change with the language, so a
  // test can read it without matching the translated text.
  const saveState = isSaving ? 'saving' : unsavedChanges ? 'unsaved' : 'saved'
  return (
    <Flex
      full
      center
      width="250px"
      padding="16px"
      flex="0"
      data-testid="editor-saved-status"
      data-save-state={saveState}
      {...props}
    >
      <Text size="12px" color="secondary">
        {status}
      </Text>
    </Flex>
  )
}

export default SavedStatus
